import local36591edfc5dc4c05ac7a31f4c7c75b43 from './lang/en-US';
import local4c30bcbb44e744ae8515743291a4e595 from './lang/zh-CN';
export default {"en-US": local36591edfc5dc4c05ac7a31f4c7c75b43,"zh-CN": local4c30bcbb44e744ae8515743291a4e595}